import { GithubOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';
import { useModel } from '@umijs/max';

const Footer: React.FC = () => {
  const { initialState } = useModel('@@initialState');
  return (
    <DefaultFooter
      style={{
        background: 'none',
        marginTop: 'auto', // 确保Footer自动推到页面底部
      }}
      links={[
        {
          key: initialState?.branding?.name || 'Anime AI Chat',
          title: initialState?.branding?.name || 'Anime AI Chat',
          href: initialState?.branding?.homeLink || 'https://github.com/AnimeAIChat/xiaozhi-server-go',
          blankTarget: true,
        },
      ]}
      copyright={initialState?.branding?.copyright || '© Anime AI Chat'}
    />
  );
};

export default Footer;
